export const LOCAL_STORAGE_AUTH_HEADER_KEY = "authHeader"
export const LOCAL_STORAGE_LANGUAGE = "language"

export const currentVersion = "v2.0.0"

export default {
  Environment: process.env.NODE_ENV,
  AmplitudeApiKey: process.env.GATSBY_AMPLITUDE_API_KEY,
}
